import type { Hit } from '@cfra-nextgen-frontend/shared/src/components/TypeSearch/types/opensearch';
import { Box, Chip } from '@mui/material';
import type { AccessibilitySecurity } from '../api/security';
import {
    getSecurityTypeColor,
    resultRowChipSx,
    resultRowSx,
} from '../styles/chartReader.styles';
import {
    ResultExchangeTypography,
    ResultNameTypography,
    ResultTickerTypography,
} from '../styles/chartReader.typography';

type SearchResultRowProps = {
    rowData: Hit<AccessibilitySecurity>;
    isSelected: boolean;
    onSelect: (security: AccessibilitySecurity) => void;
    onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>, security: AccessibilitySecurity) => void;
};

export function SearchResultRow({ rowData, isSelected, onSelect, onKeyDown }: SearchResultRowProps) {
    const { name, ticker, exchange, security_type } = rowData._source;

    return (
        <Box
            role='option'
            tabIndex={0}
            aria-selected={isSelected}
            aria-label={[name, ticker, exchange, security_type].filter(Boolean).join(', ')}
            onClick={() => onSelect(rowData._source)}
            onKeyDown={(e) => onKeyDown(e, rowData._source)}
            sx={resultRowSx}>
            <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                <ResultNameTypography>
                    {name}
                    {ticker && (
                        <ResultTickerTypography>({ticker})</ResultTickerTypography>
                    )}
                </ResultNameTypography>
                {exchange && (
                    <ResultExchangeTypography>{exchange}</ResultExchangeTypography>
                )}
            </Box>
            {security_type && (
                <Chip
                    label={security_type}
                    size='small'
                    aria-label={`Security type: ${security_type}`}
                    sx={{
                        ...resultRowChipSx,
                        backgroundColor: getSecurityTypeColor(security_type).bg,
                        color: getSecurityTypeColor(security_type).text,
                    }}
                />
            )}
        </Box>
    );
}
